const EmptyState = ({
  icon = 'inbox',
  title = 'No data found',
  description = 'Get started by adding your first item',
  actionLabel = null,
  onAction = null
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4">
      <div className="bg-neutral-100 rounded-2xl p-6 mb-5">
        <span className="material-symbols-outlined text-neutral-400 text-[56px]">
          {icon}
        </span>
      </div>
      <h3 className="text-lg font-semibold text-neutral-900 mb-2">
        {title}
      </h3>
      <p className="text-sm text-neutral-500 text-center max-w-sm mb-6">
        {description}
      </p>
      {actionLabel && onAction && (
        <button
          onClick={onAction}
          className="flex items-center gap-2 px-5 py-2.5 bg-primary hover:bg-primary-500 text-white text-sm font-semibold rounded-lg shadow-md shadow-primary/25 hover:-translate-y-0.5 transition-all"
        >
          <span className="material-symbols-outlined text-[20px]">add</span>
          <span>{actionLabel}</span>
        </button>
      )}
    </div>
  );
};

export default EmptyState;
